import React from 'react'
import RaceColumn from './../RaceColumn/RaceColumn.component'

const AgentRace = () => {
  return (
    <RaceColumn
      raceKey='agent'
      title="Agent's Race to the Royal Ring"
      subtitle='250,000 Points (approx. $8MM AV) since 01/01/2021'
    />
  )
}

export default AgentRace
